export enum MetricType {
  API = 'api',
  UI = 'ui',
}
